import React from "react";
import {
  // useTranslation,
  withTranslation,
} from "react-i18next";
import { DefaultImg } from "../../components/images";
import { Col, Row } from "antd";

const ProductOrderGift = (props: any) => {
  const { gift } = props;
  // const { t } = useTranslation();

  return (
    <div className="product-order-item-wrapper">
      <Row align="middle" className="product-order-item-wrap">
        <Col xs={12} sm={10}>
          <Row justify="center">
            <img
              src={gift.img ? gift.img : DefaultImg}
              alt=""
              className="product-order-item-image"
            />
          </Row>
        </Col>
        <Col xs={12} sm={6}>
          <Row>
            <span className="main-content item-product-name">{gift.name}</span>
          </Row>
          {gift.pattern && (
            <Row>
              <span className="main-content item-product-feature">
                {gift.pattern}
              </span>
            </Row>
          )}
          <Row>
            <span className="main-content item-product-feature">
              {gift.note}
            </span>
          </Row>
          <Row>
            <span className="main-content item-quantity">
              Số lượng:{" "}
              <span className="item-price item-quantity-value">
                {gift.quantity}
              </span>
            </span>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(ProductOrderGift);
